export function hasLowercase(password: string): boolean {
  return /[a-z]/.test(password || "");
}

export function hasUppercase(password: string): boolean {
  return /[A-Z]/.test(password || "");
}

export function hasNumber(password: string): boolean {
  return /[0-9]/.test(password || "");
}

export function hasMinLength(password: string, length: number): boolean {
  return password.length >= length;
}
